import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      onClick();
    } else {
      document.getElementById('precio')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 0 20px rgba(212, 165, 116, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative overflow-hidden group
        bg-amber hover:bg-amber-light text-midnight font-bold 
        py-4 px-8 rounded-lg transition-colors duration-300
        flex items-center justify-center gap-2 text-lg shadow-lg shadow-amber-glow
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-12">
      <span className="relative z-10" data-id="element-13">{children}</span>
      <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-14" />

      {/* Subtle shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12" data-id="element-15" />
    </motion.button>;
}